import React, { useEffect, useState } from 'react';
import Seo from '../components/Seo';
import { usefulLinksService } from '../api';
import './InfoPages.css';
import './UsefulLinksPage.css';

const CATEGORY_LABELS = {
    0: 'Ремонт и отделка',
    1: 'Агентства недвижимости',
};

const UsefulLinksPage = () => {
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        usefulLinksService.getList()
            .then(({ data }) => setLinks(data))
            .catch(() => setError('Не удалось загрузить ссылки.'))
            .finally(() => setLoading(false));
    }, []);

    const groups = links.reduce((acc, link) => {
        (acc[link.category] ||= []).push(link);
        return acc;
    }, {});

    return (
        <div className="info-page">
            <Seo title="Полезные ссылки" description="Компании по ремонту и агентства недвижимости." />
            <h1 className="info-page__title">Полезные ссылки</h1>

            {loading && <div className="info-page__placeholder">Загрузка...</div>}
            {error && <div className="info-page__placeholder">{error}</div>}
            {!loading && !error && links.length === 0 && (
                <div className="info-page__placeholder">Пока здесь пусто.</div>
            )}

            {Object.entries(groups).map(([category, items]) => (
                <div key={category} className="useful-links__group">
                    <h2 className="useful-links__heading">{CATEGORY_LABELS[category] || 'Другое'}</h2>
                    <div className="useful-links__grid">
                        {items.map((link) => (
                            <a
                                key={link.id}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="useful-links__card"
                            >
                                {link.logoUrl && <img src={link.logoUrl} alt={link.name} className="useful-links__logo" />}
                                <div className="useful-links__name">{link.name}</div>
                                {link.description && <div className="useful-links__desc">{link.description}</div>}
                            </a>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UsefulLinksPage;
